import { useState } from "react";
import { postFavorite, deleteFavorite } from "../services/favoriteService";
import { Favorite } from "../types/favorite";

type UseFavorite = {
    toggleFavorite: (action: 'Add' | 'Remove', data: Favorite) => void;
    isLoading: boolean;
    error: Error | null;
}

export const useFavorite = (): UseFavorite => {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<Error | null>(null);

    const toggleFavorite = (action: 'Add' | 'Remove', data: Favorite) => {
        setIsLoading(true);
        setError(null);
        if (action === 'Add') {
            postFavorite(data).then(response => {
            }).catch(err => {
                const error = err instanceof Error ? err : new Error('Failed to add to favorite');
                setError(error);
            }).finally(() => {
                setIsLoading(false);
            });
        } else {
            deleteFavorite(data).then(response => {
                console.log(response);
            }).catch(err => {
                const error = err instanceof Error ? err : new Error('Failed to remove from favorite');
                setError(error);
            }).finally(() => {
                setIsLoading(false);
            });
        }
    }

    return { toggleFavorite, isLoading, error };
}